import { Component, OnInit, Input } from '@angular/core';
import {Router} from '@angular/router';
import { DbServiceService } from 'src/app/services/db-service.service';

import { ConclusionComponent } from 'src/app/components/conclusion/conclusion.component';

@Component({
  selector: 'results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.css']
})
export class ResultsComponent implements OnInit {

  @Input() uuid: string;

  overallStage: string = "";
  overallDescription: string = "";
  overallColor: string = "";

  pillar1Stage: string = "";
  pillar1Score: string = "";
  pillar1Color: string = "";

  pillar2Stage: string = "";
  pillar2Score: string = "";
  pillar2Color: string = "";

  pillar3Stage: string = "";
  pillar3Score: string = "";
  pillar3Color: string = "";

  pillar4Stage: string = "";
  pillar4Score: string = "";
  pillar4Color: string = "";

  showGrant: string = "";

  reportSent: number = 0;

  scoreImagePath: string = location.origin + "/ibg-eforms/sg/sustainability-accel-tool/assets/images/";

  constructor(private dbService: DbServiceService, private router:Router) { }

  ngOnInit(): void {
    const draftReportSent = localStorage.getItem("reportSent");
    if (draftReportSent) this.reportSent = JSON.parse(draftReportSent);

    this.dbService.computeSurveyScores(this.uuid).subscribe(
      data => {
        var results = data.split("|");
        var index = 0;
        this.overallStage = results[index++];
        this.overallDescription = results[index++];
        this.overallColor = results[index++];
        this.pillar1Stage = results[index++];
        this.pillar1Score = this.scoreImagePath + results[index++];
        this.pillar1Color = results[index++];
        this.pillar2Stage = results[index++];
        this.pillar2Score = this.scoreImagePath + results[index++];
        this.pillar2Color = results[index++];
        this.pillar3Stage = results[index++];
        this.pillar3Score = this.scoreImagePath + results[index++];
        this.pillar3Color = results[index++];
        this.pillar4Stage = results[index++];
        this.pillar4Score = this.scoreImagePath + results[index++];
        this.pillar4Color = results[index++];
        this.showGrant = results[index++];
      }
    );
  }

  mailReport() {
    this.dbService.generateSurveyReport(this.uuid).subscribe(
       data => {
    });

    this.reportSent = 2;
    localStorage.setItem("reportSent", JSON.stringify(this.reportSent));
  }
}
